export function ShoppingCartButton() {
	const ArrowLeftIcon = props => (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_941_317)">
				<path
					d="M8.75 3.5L5.25 7L8.75 10.5"
					stroke="#5D6776"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_941_317">
					<rect
						width="14"
						height="14"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);

	return (
		<>
			<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-shopping-cart-button">
				{/* <a
					href=""
					className="wp-checkout-arrow-left-icon"
				>
					<ArrowLeftIcon />
				</a> */}
				<span className="wp-checkout-font-base wp-checkout-cart-text">
					Shopping Cart /
				</span>
				<span className="wp-checkout-font-base wp-checkout-cart-text-bold">
					Checkout
				</span>
			</div>
		</>
	);
}
